import React from "react";
import { Templates, useTemplate } from "@/util-react/template";
import { HomePageDefaultMobile } from "@/pages-react/home-page/templates/home-page.default";
import { HomePageBlackAndBlueMobile } from "@/pages-react/home-page/templates/home-page.black-and-blue";

const templates: Record<Templates, React.ComponentType | null> = {
  [Templates.DEFAULT]: HomePageDefaultMobile,
  [Templates.BLACK_AND_BLUE]: HomePageBlackAndBlueMobile,
};

export const HomePageMobile = () => {
  const template = useTemplate();

  const TemplatedComponent = templates[template.template ?? Templates.DEFAULT];

  return TemplatedComponent ? <TemplatedComponent /> : null;
};
